import React from "react";
import Input from "../../../../ui/common/Input";
import ToggleSwitch from "../../../../ui/toggleSwitch/ToggleSwitch";
import "./TentaclesSettingsForms.scss";
import { getFieldValue } from "../fieldValue";

const ABTestSettingsForm = ({ data, handleChanges, cdnStatus }) => {
  return (
    <div className="inputs-container">
      <Input
        label="AB Confidence Alpha"
        type="number"
        value={getFieldValue(data.ABConfidenceAlpha)}
        onChange={(e) => {
          handleChanges("ABConfidenceAlpha", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB Uniform Distribution Time"
        type="number"
        value={getFieldValue(data.ABUniformDistributionTime)}
        onChange={(e) => {
          handleChanges("ABUniformDistributionTime", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB aggression Factor"
        type="number"
        value={getFieldValue(data.ABaggressionFactor)}
        onChange={(e) => {
          handleChanges("ABaggressionFactor", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB archive Days"
        type="number"
        value={getFieldValue(data.ABarchiveDays)}
        onChange={(e) => {
          handleChanges("ABarchiveDays", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.ABimageTesting)}
          onChange={(e) => {
            handleChanges("ABimageTesting", e);
          }}
        />
        <span className="switch-label"> AB image Testing</span>
        <div className="cdn-status-indicator" style={{ marginLeft: '55px', fontSize: '12px' }}>
          {cdnStatus.isLoading ? (
            <span style={{ color: '#666' }}>Checking Image CDN...</span>
          ) : cdnStatus.error ? (
            <span style={{ color: '#ff4444' }}>Image CDN check failed</span>
          ) : cdnStatus.active === true ? (
            <span style={{ color: '#44aa44' }}>✓ Image CDN Active</span>
          ) : cdnStatus.active === false ? (
            <span style={{ color: '#ff4444' }}>✗ Image CDN Inactive</span>
          ) : (
            <span style={{ color: '#666' }}>Image CDN status unknown</span>
          )}
        </div>
      </div>
      <Input
        label="AB margin Factor"
        type="number"
        value={getFieldValue(data.ABmarginFactor)}
        onChange={(e) => {
          handleChanges("ABmarginFactor", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB margin Start"
        type="number"
        value={getFieldValue(data.ABmarginStart)}
        onChange={(e) => {
          handleChanges("ABmarginStart", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB max Clicks"
        type="number"
        value={getFieldValue(data.ABmaxClicks)}
        onChange={(e) => {
          handleChanges("ABmaxClicks", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB max Runtime"
        type="number"
        value={getFieldValue(data.ABmaxRuntime)}
        onChange={(e) => {
          handleChanges("ABmaxRuntime", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB probability Factor"
        type="number"
        value={getFieldValue(data.ABprobabilityFactor)}
        onChange={(e) => {
          handleChanges("ABprobabilityFactor", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="AB probability Start"
        type="number"
        value={getFieldValue(data.ABprobabilityStart)}
        onChange={(e) => {
          handleChanges("ABprobabilityStart", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.ABuseCTR)}
          onChange={(e) => {
            handleChanges("ABuseCTR", e);
          }}
        />
        <span className="switch-label"> AB use CTR</span>
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.ABuseLTR)}
          onChange={(e) => {
            handleChanges("ABuseLTR", e);
          }}
        />
        <span className="switch-label"> AB use LTR</span>
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.ABuseCTRConfidence)}
          onChange={(e) => {
            handleChanges("ABuseCTRConfidence", e);
          }}
        />
        <span className="switch-label"> AB use CTR Confidence</span>
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.ABuseLTRConfidence)}
          onChange={(e) => {
            handleChanges("ABuseLTRConfidence", e);
          }}
        />
        <span className="switch-label"> AB use LTR Confidence</span>
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.ABuseSmartOctoScore)}
          onChange={(e) => {
            handleChanges("ABuseSmartOctoScore", e);
          }}
        />
        <span className="switch-label"> AB use SmartOcto Score </span>
      </div>
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.ABuseThompson)}
          onChange={(e) => {
            handleChanges("ABuseThompson", e);
          }}
        />
        <span className="switch-label"> AB use Thompson </span>
      </div>
      <Input
        label="Minimal CTR"
        type="number"
        value={getFieldValue(data.minimalCTR)}
        onChange={(e) => {
          handleChanges("minimalCTR", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Minimal CTR diff"
        type="number"
        value={getFieldValue(data.minimalCTRdiff)}
        onChange={(e) => {
          handleChanges("minimalCTRdiff", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
            <Input
        label="Minimal LTR"
        type="number"
        value={getFieldValue(data.minimalLTR)}
        onChange={(e) => {
          handleChanges("minimalLTR", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Minimal LTR diff"
        type="number"
        value={getFieldValue(data.minimalLTRdiff)}
        onChange={(e) => {
          handleChanges("minimalLTRdiff", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <Input
        label="Minimal Total Impressions"
        type="number"
        value={getFieldValue(data.minimalTotalImpressions)}
        onChange={(e) => {
          handleChanges("minimalTotalImpressions", e.target.valueAsNumber);
        }}
        fullWidth
        separateLines
      />
      <div className="switch-container">
        <ToggleSwitch
          checked={getFieldValue(data.storeHeadertestStatistics)}
          onChange={(e) => {
            handleChanges("storeHeadertestStatistics", e);
          }}
        />
        <span className="switch-label"> Store Headertest Statistics </span>
      </div>
    </div>
  );
};

export default ABTestSettingsForm;
